import React, { useRef } from "react";
import Markdown from "@sui/chat-ui/es/ChatUI/components/markdown";
import useBaseRequest from "@/hooks/useBaseRequest";
import { getModelDetail } from "@/api/index";
import "./detail.less";
import { message } from "antd";



function DrawDetail(props) {
    const {
        id
    } = props
    const {
        data: initata,
        loading: loading2
    } = useBaseRequest(() => getModelDetail(id), {
        // manual: true,
    })
    const markRef = useRef()

    function readClipboardLegacy(val) {
        const textarea = document.createElement('textarea');
        textarea.value = val
        document.body.appendChild(textarea);
        textarea.focus();
        document.execCommand('paste'); // 触发粘贴到文本域
        const text = textarea.value;
        document.body.removeChild(textarea);
        message.success("复制成功")
        return text;
    }
    // 复制到剪贴板函数
    const copyToClipboard = async (text) => {
        try {
            // 使用现代浏览器的Clipboard API
            await navigator.clipboard.writeText(text);

            // 更新状态以显示成功反馈
            // setIsCopied(true);
            // setShowTooltip(true);

            // 2秒后重置状态
            setTimeout(() => {
                // setIsCopied(false);
            }, 2000);

            // 3秒后隐藏提示
            setTimeout(() => {
                // setShowTooltip(false);
            }, 3000);
            message.success("复制成功")
        } catch (err) {
            console.error('复制失败:', err);
            // 降级方案：使用传统方法
            fallbackCopyTextToClipboard(text);
        }
    };

    // 降级方案：传统复制方法
    const fallbackCopyTextToClipboard = (text) => {
        const textArea = document.createElement("textarea");
        textArea.value = text;

        // 避免屏幕滚动
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            const successful = document.execCommand('copy');
            if (successful) {
                // setIsCopied(true);
                // setShowTooltip(true);

                setTimeout(() => {
                    // setIsCopied(false);
                }, 2000);

                setTimeout(() => {
                    // setShowTooltip(false);
                }, 3000);
            }
        } catch (err) {
            console.error('降级复制方案也失败了:', err);
            // alert('复制失败，请手动选择文本进行复制');
        }
        message.success("复制成功")
        document.body.removeChild(textArea);
    };



    return <>
        <div className="jj">
            <div className="title">简介</div>
            <div className="des">{initata?.data?.description}</div>
        </div>
        <div className="apiCotent">
            <div className="topTitle">
                <div className="name">API调用示例</div>
                {/* <div className="copy" onClick={() => {
                    copyToClipboard(initata?.data?.usage_example)
                }}>复制</div> */}
            </div>
            <div>
                <Markdown ref={markRef} data={{
                    think: null,
                    thinking: false,
                    content: initata?.data?.usage_example || ""
                }}>
                </Markdown>
            </div>
        </div>
        <div className="apiCotent">
            <div className="topTitle">
                <div className="name">调用响应示例</div>
                {/* <div className="copy" onClick={() => {
                    copyToClipboard(initata?.data?.response_example)
                }}>复制</div> */}
            </div>
            <div>
                <Markdown data={{
                    think: null,
                    thinking: false,
                    content: initata?.data?.response_example || ""
                }}>
                </Markdown>
            </div>
        </div>

    </>
}

export default DrawDetail